<template>
  <aside id="side-menu">
    <sidebar-menu :menu="menu" :collapsed="false" :hide-toggle="true" @item-click="onItemClick" width="200px">
      <span slot="toggle-icon"><font-awesome-icon style="cursor: pointer" icon="arrows-alt-h"/></span>
      <span slot="dropdown-icon"><font-awesome-icon style="cursor: pointer" icon="angle-right"/></span>
    </sidebar-menu>
  </aside>
</template>

<script>
const logoImg = {
  data () {
    return {
      src: '/static/img/logo_negativo.png'
    }
  },
  template: '<div class="menu-header"><img class="site-logo" :src="src"></div>'
}
export default {
  name: 'Sidebar',
  props: ['collapsed'],
  data () {
    return {
      menu: [
        {
          header: true,
          component: logoImg,
          hiddenOnCollapse: true
        },
        {
          href: '/admin/licences',
          title: 'Licencias LTI',
          icon: 'fa fa-plug'
        },
        {
          href: '/admin/sessions',
          title: 'Clases en directo',
          icon: 'fa fa-video-camera'
        },
        {
          href: '/admin/users',
          title: 'Usuarios',
          icon: 'fa fa-users'
        },
        {
          href: '/admin/recording-reprocess',
          title: 'Estado grabaciones',
          icon: 'fa fa-play'
        },
        {
          title: 'Cerrar sesión',
          icon: 'fa fa-power-off'
        }
      ]
    }
  },
  methods: {
    onToggleCollapse (collapsed) {
      this.$emit('toggleCollapse', collapsed)
    },
    onItemClick (event, item, node) {
      if (item.icon === 'fa fa-power-off') {
        this.$cookies.remove('LTI_JWT')
        this.$router.push({name: 'LoginAdmin'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Sidebar.vue